import { Typography } from '@mui/material';
import React, { useContext } from 'react';
import { ContactInput } from 'sr-types/lib/person/v1/graphql';
import { groupContactsByRole } from '../../../common/components/contacts/contactDisplayUtils';
import { FormContext } from '../../../common/form/FormContext';
import { useI18n } from '../../../common/i18n/I18n';
import { V } from '../../../common/Layout';
import BusinessContactSection from './BusinessContactSection';

type BusinessContactsPreviewProps = {
    onEdit: (contact: ContactInput) => void;
    directDeleteContact: boolean;
};

export const BUSINESS_CONTACTS_PREVIEW_PRIMARY_ROLE_HEADING_TEST_ID = 'business-contacts-preview-primary-role-heading';
export const BUSINESS_CONTACTS_PREVIEW_ROLE_HEADING_TEST_ID = 'business-contacts-preview-role-heading';
const CONTACT_ROLE_HEADING_SX = {
    color: 'text.secondary',
    fontSize: '16px',
    lineHeight: 1.25
};

export default function BusinessContactsPreview({
    onEdit,
    directDeleteContact
}: BusinessContactsPreviewProps) {
    const { state } = useContext(FormContext);
    const t = useI18n();
    const businessContacts = state?.businessContacts || [];
    const primaryBusinessContacts = businessContacts.filter((contact: ContactInput) => contact.isPrimary);
    const nonPrimaryBusinessContacts = businessContacts.filter((contact: ContactInput) => !contact.isPrimary);
    const primaryBusinessContactGroups = groupContactsByRole(
        primaryBusinessContacts,
        t('shortlist.representative.role.unspecified')
    );
    const businessContactGroups = groupContactsByRole(
        nonPrimaryBusinessContacts,
        t('shortlist.representative.role.unspecified')
    );

    return primaryBusinessContactGroups.length || businessContactGroups.length ? (
        <V gap={1} sx={{ overflowY: 'auto', alignItems: 'flex-start' }}>
            {primaryBusinessContactGroups.map((group) => (
                <V key={`primary-${group.role}`} gap={1}>
                    <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        sx={CONTACT_ROLE_HEADING_SX}
                        data-testid={BUSINESS_CONTACTS_PREVIEW_PRIMARY_ROLE_HEADING_TEST_ID}
                    >
                        {group.role}
                    </Typography>
                    {group.contacts.map((contact: ContactInput) => (
                        <BusinessContactSection
                            key={contact.personReference.id}
                            contact={contact}
                            onEdit={onEdit}
                            directDeleteContact={directDeleteContact}
                        />
                    ))}
                </V>
            ))}
            {businessContactGroups.map((group) => (
                <V key={group.role} gap={1}>
                    <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        sx={CONTACT_ROLE_HEADING_SX}
                        data-testid={BUSINESS_CONTACTS_PREVIEW_ROLE_HEADING_TEST_ID}
                    >
                        {group.role}
                    </Typography>
                    {group.contacts.map((contact: ContactInput) => (
                        <BusinessContactSection
                            key={contact.personReference.id}
                            contact={contact}
                            onEdit={onEdit}
                            directDeleteContact={directDeleteContact}
                        />
                    ))}
                </V>
            ))}
        </V>
    ) : (
        <></>
    );
}
